import React, { useState, useEffect } from "react"
import _ from "lodash"
import { alphanum } from "components/table/lib/sort"
import { CheckboxInput, ListboxInput, NamedItemInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

const Detailed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {}
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [data, setData] = useState<object|null>(props.rowData[props.field]);
  const [showSelected, setShowSelected] = useState<boolean>(props.rowData[props.field]?.items?.length > 0);

  useEffect(() => {
    if (!props['rowData'][props.field]) setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    if (field === 'items'){
      let items = val
      if (items && items[0] === "") items.shift();
      items = items.map(item => { return { 'tenantGroupId': item }})
      nextData[field] = items
    } else {
      nextData[field] = val
    }
    setData(nextData);
    props.persist({...nextData}, 'tenantgroupdetail', props.rowData)
  }

  const attrs                 = (field) => field_attrs('tenantcontribution')(field)(props.rowData, props)
  let tenantGroups            = props.namedItems['tenantGroups'];
  let tenantContributionsData = _.cloneDeep(data);
  tenantContributionsData     = tenantContributionsData && tenantContributionsData['items'] ? tenantContributionsData['items'].map(item => item.tenantGroupId) : null

  if (showSelected && tenantContributionsData){
    tenantGroups = tenantGroups.filter(tenantGroup => tenantContributionsData.includes(tenantGroup.tenantgroupid));
  }

  function selectAll():void {
    data && data['items'] && data['items'].length === tenantGroups.length ? updateData([], 'items') : updateData(tenantGroups.map(leaseType => leaseType.tenantgroupid), 'items')
  }

  if (sortDirty){
    sortAsc ? tenantGroups.sort((a, b) => alphanum(a.name, b.name)) : tenantGroups.sort((a, b) => alphanum(b.name, a.name))
  }
  
  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Report Tag</label>
          <NamedItemInput className="automated" data={props.rowData[props.field]} attrs={attrs} field="reportTagNamedItemId" options={props.namedItems['reportTags']} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
      <hr />
      <SingleRowCarouselState_s>
        <div>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
        </div>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Tenant Groups</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated" data={{allSelected: tenantContributionsData ? tenantContributionsData.length === tenantGroups.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": tenantContributionsData}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={updateData}
            options={tenantGroups.map(tenantGroup => { return {label: `${tenantGroup.code} ${tenantGroup.name ? '-' : ''} ${tenantGroup.name || ''}`, value: tenantGroup.tenantgroupid}})}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default Detailed
